import { type FC, useMemo } from "react";
import { useMatchMinute } from "../../../../hooks/use-match-minute";
import { type Post, PostType } from "../../../../types/post.types";
import PostFooter from "../../components/post-footer/post-footer";
import PostHeader from "../../components/post-header/post-header";
import PostText from "../../components/post-text/post-text";
import * as CSS from "./key-moment-post.styles";

type StandardPostProps = {
	post: Post;
};

const KeyMomentPost: FC<StandardPostProps> = ({ post }) => {
	const getKeyMomentTitle = useMemo(() => {
		if (post.type === PostType.PENALTY) {
			return "Penalty!";
		}

		if (post.keyMomentType === "chance") {
			return "Chance!";
		}

		if (post.keyMomentType === "big_chance") {
			return "Big chance!";
		}
	}, [post]);

	const minute = useMatchMinute(post.date, post.minute);

	return (
		<CSS.Post>
			<PostHeader
				time={minute}
				type={post.type}
			/>
			<div style={{ marginLeft: 44 }}>
				<CSS.Title $type={post.type}>
					{getKeyMomentTitle}
				</CSS.Title>
				<PostText postId={post.id} text={post.text} />
				<PostFooter postId={post.id} postType={post.type} />
			</div>
		</CSS.Post>
	);
};

export default KeyMomentPost;
